import React from "react";

const Footer = () => {
  return (
    <footer className="p-4 footer bg-base-300 text-base-content footer-center">
      <div className="card compact bg-base-100 shadow">
        <div className="card-body">
          <div>Build with ❤️ Kartik Budhraja</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
